import { Component, OnInit, ViewChild } from '@angular/core';
import { DateTime } from '../../dateTime';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { ReportService } from '../services/report.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { SportService } from '../services/sport.service';
import { MatPaginator } from '@angular/material/paginator';
@Component({
  selector: 'app-my-bet',
  templateUrl: './my-bet.component.html',
  styleUrls: ['./my-bet.component.scss']
})
export class MyBetComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  myBetsDisplayedColumns: string[] = ['number','market_name','selection_name', 'odds', 'stack', 'p_l', 'result', 'is_back', 'createdAt']
  myBetsDataSource: any;
  selectedMarket: any;
  param: any;
  matchData: any;
  betData: any;
  userData: any;
  match_id: any;
  market_id: any;
  typeId: any;
  betStartDate: Date = new Date()
  betEndDate: Date = new Date()
  sport_name: string;
  series_name: string;
  match_name: string;
  length: any
  pageIndex: number;
  searchSelection: any
  searchUser: any
  searchMarket: any
  searchSport: any
  searchSeries: any
  searchRate: any;
  searchStake: any
  searchBetType: any
  searchSelectionId: any;
  selectionList: any;
  betType: any;
  market_name: any;
  pageLimit: number = 50;
  bet: any;
  constructor(public toastr: ToastrService, private router: Router, private sportService: SportService, private locationBack: Location, private reportService: ReportService, private route: ActivatedRoute, private location: Location) {
    this.route.params.subscribe((params) => {
      this.match_id = params.matchId;
      this.market_id = params.marketId;
      this.typeId = params.type;
    });
  }




  ngOnInit() {
    this.betStartDate.setHours(0, 0, 0, 0);
    this.betEndDate.setHours(23, 59, 59)
    this.getBetsByMarketId()
  }


  getBetsByMarketId(from?: string) {
    this.userData = JSON.parse(localStorage.getItem('userDetails'))
    let data;
    if (this.betType == 'All') {
      this.bet = '';
    } else if (this.betType == 'Back') {
      this.bet = '1';
    } else if (this.betType == 'Lay') {
      this.bet = '0';
    }
    if (from == 'onFilter') {
      if (this.typeId == 1) {
        data = {
          "match_id": this.match_id,
          // "limit": this.pageLimit,
          // "page": this.pageIndex,
          "search": {
            "market_id": this.market_id == undefined ? '' : this.market_id,
            "selection_name": this.searchSelection == undefined ? '' : this.searchSelection,
            "is_back": this.bet == undefined ? '' : this.bet,
            "odds": this.searchRate == undefined ? '' : this.searchRate,
            "stack": this.searchStake == undefined ? '' : this.searchStake
          }
        }
      } else if (this.typeId == 2) {
        data = {
          "match_id": this.match_id,
          // "limit": this.pageLimit,
          // "page": this.pageIndex,
          "search": {
            "fancy_id": this.market_id == undefined ? '' : this.market_id,
            "is_back": this.bet == undefined ? '' : this.bet,
            'is_fancy': 1,
            "run": this.searchRate == undefined ? '' : this.searchRate,
            "stack": this.searchStake == undefined ? '' : this.searchStake
          }
        }
      }
    } else {
      if (this.typeId == 1) {
        data = {
          "match_id": this.match_id,
          // "limit": this.pageLimit,
          // "page": this.pageIndex,
          "search": {
            "market_id": this.market_id == undefined ? '' : this.market_id,
          }
        }
      } else {
        data = {
          "match_id": this.match_id,
          // "limit": this.pageLimit,
          // "page": this.pageIndex,
          "search": {
            "fancy_id": this.market_id == undefined ? '' : this.market_id,
          }
        }
      }
    }
    if (data.search.fancy_id == '') {
      delete data.search.fancy_id
    }
    if (data.search.market_id == '') {
      delete data.search.market_id
    }
    if (data.search.selection_name == '') {
      delete data.search.selection_name
    }
    if (data.search.user_name == '') {
      delete data.search.user_name
    }
    if (data.search.is_back == '') {
      delete data.search.is_back
    }
    if (data.search.run == '') {
      delete data.search.run
    }
    if (data.search.stack == '') {
      delete data.search.stack
    }
    if (data.search.odds == '') {
      delete data.search.odds
    }
    this.reportService.plBets(data).subscribe((res) => {
      if (res.status == true) {
        this.betData = res.data;
        this.sport_name = this.betData[0].sport_name;
        this.series_name = this.betData[0].series_name;
        this.match_name = this.betData[0].match_name;
        this.market_name = this.betData[0].market_name;
        this.myBetsDataSource = this.betData
        this.length = this.myBetsDataSource.length
        this.pageIndex = res.data
      } else {
       this.toastr.error(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 5000
        });

      }
    })
  }
  goToBack() {
    this.router.navigate(['/reports/profitLoss'])
  }
  pageChange(event) {
    this.pageIndex = event.pageIndex + 1
    this.getBetsByMarketId()
  }




  onClickFilterViewBets(selection?: any) {
    if (selection) {
      this.searchSelection = selection.selection_name
      this.searchSelectionId = selection.selection_id
    }

    this.getBetsByMarketId('onFilter')
  }

  clear() {
    this.searchSelection = undefined
    this.searchSelectionId = undefined
    this.searchRate = undefined
    this.searchStake = undefined
    this.betType = undefined
    this.getBetsByMarketId()
  }
}
